export function hexToRgb(hex: string): [number, number, number] {
    // https://stackoverflow.com/a/11508164/735425
    hex = hex.replace(/[^0-9A-F]/gi, '');

    const int = parseInt(hex, 16);
    const r = (int >> 16) & 255;
    const g = (int >> 8) & 255;
    const b = int & 255;

    return [r, g, b];
}

export function isBrightRGB(r: number, g: number, b: number): boolean {
    // http://www.w3.org/TR/AERT#color-contrast
    const brightness = Math.round(((r * 299) + (g * 587) + (b * 114)) / 1000);
    return (brightness > 125);
}

export function isBrightHex(hex: string): boolean {
    const rgb = hexToRgb(hex);
    return isBrightRGB(rgb[0], rgb[1], rgb[2]);
}